import React from 'react';
import css from './about.scss';

export function Values() {
  return (
    <div className={css.ourValues}>
      <div className={css.container}>
        <ul className={css.grid}>
          <li>
            <h3>Our Vision</h3>
            Transforming the personal growth and coaching markets by leveraging the latest mobile, social, and web technologies to deliver engaging user experience, exceptional design and effective applications.
          </li>
          <li>
            <h3>Our Team</h3>
            Since our foundation we have assembled a diverse team of world-class coaches, human development experts and other dedicated professionals that bring power and scope to everything we do, and who all share our common vision and core values.
          </li>
          <li>
            <h3>Our Values</h3>
            <div>Values are at the core of everyone's life. As a company, we want Success Wizard to also be guided by the values that represent who we are and how we want to be in the world.</div>
            <dl className={css.descriptionList}>
              <dt>Authenticity</dt>
              <dd>Be ourselves and stay true to our core values</dd>
              <dt>Integrity</dt>
              <dd>Do what we say and say what we do</dd>
              <dt>Quality</dt>
              <dd>Strive for professionalism, proficiency and excellence</dd>
              <dt>Community</dt>
              <dd>Create supportive, peaceful and nurturing environment</dd>
              <dt>Contribution</dt>
              <dd>Leverage our knowledge, drive and passion to help others</dd>
              <dt>Health</dt>
              <dd>Support healthy, balanced and fulfilling lifestyle</dd>
              <dt>Growth</dt>
              <dd>Keep learning, developing and realizing our full potential</dd>
              <dt>Fun</dt>
              <dd>Live joyfully, with harmony and ease</dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  );
}
